import React from 'react';
import { FaParking, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import ReactDOM from 'react-dom';
import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Popper, Grow, Paper, ClickAwayListener, MenuList, Avatar, Drawer, Grid, Button, Switch } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import './NavBar.css';
import SettingDialogPopop from './SettingDialog/SettingDialogPopop';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import GeneralSettingDialogPopop from './GeneralSettingDialog/GeneralSettingDialogPopop';
import TransactionService from '../../Services/TransactionService';
import { ShowAlert } from '../../Component/ShowAlert';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import BankPartners from './BankPartners.tsx/BankPartnersList';

interface NavBarTopProps {}
interface NavBarTopState {
    userDetails: UserDetailsModel,
    platformFee: boolean,
    isGeneralSetting: boolean,
    // isNotificationOpened: boolean,
    // drawerId: number,
    // isScheduleOpened: boolean
    transactionStatus: boolean,
    cardStatus: boolean,
    isOpenFintechBankMapping: boolean
    isOpenNetworkMapping: boolean
}

interface UserDetailsModel {
    accessToken: string;
    first_name: string;
    last_name: string;
    email: string;
    fullName: string;
    mobile_number: string;
}


class NavBarTop extends React.Component<NavBarTopProps, NavBarTopState> {
    static contextType = SyncContext;
    context!: SyncContextType;
    constructor(props: NavBarTopProps) {
        super(props);

        this.state = {
            userDetails: {
                accessToken: '',
                fullName: '',
                email: '',
                first_name: '',
                last_name: '',
                mobile_number: ''
            },
            platformFee: false,
            isGeneralSetting: false,
            // isNotificationOpened: false,
            // drawerId: 0,
            // isScheduleOpened: false
            transactionStatus: false,
            cardStatus: false,
            isOpenFintechBankMapping: false,
            isOpenNetworkMapping: false
        };
    }

    async componentDidMount() {
        const _accessToken = await loadFromLocalStorage('accessToken');
        let _localData = localStorage.getItem('profile');

        if (_localData != null && _localData !== '' && _accessToken != null && _accessToken != '') {
            let _data = JSON.parse(_localData);

            let _userDetails: UserDetailsModel = _data;
            _userDetails.fullName = `${_userDetails.first_name} ${_userDetails.last_name}`;
            _userDetails.accessToken = _accessToken.toString()

            this.getTransactionStatus(_userDetails.accessToken);
            this.getCardStatus(_userDetails.accessToken);

            this.setState({
                userDetails: _userDetails,
            });
        }
    }

    private getTransactionStatus(accessToken: string) {
        TransactionService.getTransactionStatus(accessToken).then(r => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({
                        transactionStatus: resp.transactionStatus
                    });
                });
            }
        });
    }

    private getCardStatus(accessToken: string) {
        TransactionService.getCardStatus(accessToken).then(r => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({
                        cardStatus: resp.cardStatus
                    });
                });
            }
        });
    }

    public render() {
        const { profileSettings } = this.context.state.permissions;
        return (
            <div>
                <TopHeaderSource
                    userInfo={this.state.userDetails}
                    transactionStatus={this.state.transactionStatus}
                    cardStatus={this.state.cardStatus}
                    popupState={(s_) => {
                        if (s_ == 'exchangeRate') {
                            this.setState({
                                platformFee: true
                            })
                        } else if (s_ == 'general') {
                            this.setState({
                                isGeneralSetting: true
                            })
                        } else if (s_ == 'fintechBanking') {
                            console.log(s_)
                            this.setState({
                                isOpenFintechBankMapping: true
                            })
                        } else if (s_ == 'networks') {
                            this.setState({
                                isOpenNetworkMapping: true
                            })
                        }

                    }}
                    profileSettings={profileSettings}
                />
                {/* {
                    this.state.platformFee && this.state.userDetails.accessToken && <SettingDialogPopop
                        open={this.state.platformFee}
                        onClose={(state: boolean, action: string) => {
                            this.setState({
                                platformFee: false
                            })
                        }}
                        accessToken={this.state.userDetails.accessToken}
                    />
                } */}
                {
                    this.state.isGeneralSetting && this.state.userDetails.accessToken && <GeneralSettingDialogPopop
                        open={this.state.isGeneralSetting}
                        onClose={(state: boolean, action: string) => {
                            this.setState({
                                isGeneralSetting: false
                            })
                        }}
                        accessToken={this.state.userDetails.accessToken}
                    />
                }
                {
                    this.state.isOpenFintechBankMapping && this.state.userDetails.accessToken &&
                    (() => {
                        this.setState({
                            isOpenFintechBankMapping: false
                        });
                        window.location.href = "/bankpartners";
                        return null;
                    })()
                }
                {
                    this.state.isOpenNetworkMapping && this.state.userDetails.accessToken &&
                    (() => {
                        this.setState({
                            isOpenNetworkMapping: false
                        });
                        window.location.href = "/networks";
                        return null;
                    })()
                }
            </div >
        )
    }
}

function TopHeaderSource(props: { userInfo: UserDetailsModel, transactionStatus: boolean, cardStatus: boolean, popupState: (s_: string) => void, profileSettings: any }) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [checked, setChecked] = React.useState(props.transactionStatus);
    const [cardChecked, setCardChecked] = React.useState(props.cardStatus);
    React.useEffect(() => {
        setChecked(props.transactionStatus);
    }, [props.transactionStatus]);

    React.useEffect(() => {
        setCardChecked(props.cardStatus);
    }, [props.cardStatus]);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLogOut = () => {
        localStorage.clear();
        window.location.href = "/";
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSetting = (param: string) => () => {
        setAnchorEl(null);
        if (props.popupState) {
            props.popupState(param);
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let pauseTransactionStatus = event.target.checked;
        let message: string;
        let status: string;
        setChecked(pauseTransactionStatus);
        let payload: any = {
            "isChecked": pauseTransactionStatus
        };

        if (pauseTransactionStatus) {
            message = "Pause Transaction has been enabled";
            status = "success";
        } else {
            message = "Pause Transaction has been disabled";
            status = "warning";
        }
        TransactionService.UpdateTransactionStatus(props.userInfo.accessToken, payload).then(r => {
            if (r.ok) {
                ShowAlert("PassportPay", message, status);
            }
        });
    };

    const handleCardChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let cardVerificationStatus = event.target.checked;
        let message: string;
        let status: string;
        setCardChecked(cardVerificationStatus);
        let payload: any = cardVerificationStatus;

        if (cardVerificationStatus) {
            message = "Card Verification has been enabled";
            status = "success";
        } else {
            message = "Card Verification has been disabled";
            status = "warning";
        }
        TransactionService.UpdateCardStatus(props.userInfo.accessToken, payload).then(r => {
            if (r.ok) {
                ShowAlert("PassportPay", message, status);
            }
        });
    };

    const getUserProfileText = () => {
        let userAlpha = '';
        if (props.userInfo.fullName !== null && props.userInfo.fullName != '') {
            let userNameArray = props.userInfo.fullName.split(' ');
            let userAlphaList: any[] = [];

            for (let user of userNameArray) {
                userAlphaList.push(user[0]);
            }

            /*for (let i = 0; i < userNameArray.length; i++) {
                userAlphaList.push(userNameArray[i][0]);
            }*/

            userAlpha = userAlphaList.toString().replace(/,/g, '');
        }

        return userAlpha;
    }

    const stringToColor = (string: string) => {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }


    return (
        <AppBar position="static" className='top-header-container'>
            <Toolbar className='header-container'>
                <div className="header-container-sub">
                    <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="default"
                    >
                        <Avatar className='profile-icon' style={{ background: stringToColor(getUserProfileText()) }}>{getUserProfileText()}</Avatar>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        className="profile-popup"
                        anchorEl={anchorEl}
                        elevation={3}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={open}
                        onClose={handleClose}
                    >
                        {/* {props.profileSettings.isExchangeRateVisible &&
                            <MenuItem onClick={handleSetting("exchangeRate")}
                                sx={{ borderBottom: props.profileSettings.isExchangeRateVisible? '1px solid #ddd' : 'none' }}>
                                Exchange Rate
                            </MenuItem>} */}

                        {props.profileSettings.isGeneralSettingsVisible &&
                            <MenuItem onClick={handleSetting("general")}
                                sx={{ borderBottom: props.profileSettings.isGeneralSettingsVisible ? '1px solid #ddd' : 'none' }}>
                                General Settings
                            </MenuItem>}
                        {
                            <MenuItem onClick={handleSetting("fintechBanking")}
                                sx={{ borderBottom: '1px solid #ddd' }}>
                                Bank Partners
                            </MenuItem>
                        }
                        {
                            <MenuItem onClick={handleSetting("networks")}
                                sx={{ borderBottom: '1px solid #ddd' }}>
                                Networks
                            </MenuItem>
                        }

                        {props.profileSettings.isPauseTransactionVisible &&
                            <MenuItem onClick={handleSetting("transactionStatus")}
                                sx={{ borderBottom: props.profileSettings.isPauseTransactionVisible ? '1px solid #ddd' : 'none' }}
                            >
                                Pause Transaction
                                <Switch
                                    checked={checked}
                                    onChange={handleChange}
                                    sx={{
                                        '& .MuiSwitch-thumb': {
                                            backgroundColor: checked ? "#5aac3d" : "#898989",
                                        },
                                        '& .MuiSwitch-track': {
                                            backgroundColor: checked ? "#5aac3d" : "#898989",
                                        },
                                        '& .Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: "#5aac3d",
                                        },
                                        '& .Mui-checked .MuiSwitch-thumb': {
                                            backgroundColor: "#5aac3d",
                                        }
                                    }}
                                />
                            </MenuItem>}
                        {props.profileSettings.isCardVerification &&
                            <MenuItem onClick={handleSetting("cardStatus")}
                                sx={{ borderBottom: props.profileSettings.isCardVerification ? '1px solid #ddd' : 'none' }}
                            >
                                Card Verification
                                <Switch
                                    checked={cardChecked}
                                    onChange={handleCardChange}
                                    sx={{
                                        '& .MuiSwitch-thumb': {
                                            backgroundColor: cardChecked ? "#5aac3d" : "#898989",
                                        },
                                        '& .MuiSwitch-track': {
                                            backgroundColor: cardChecked ? "#5aac3d" : "#898989",
                                        },
                                        '& .Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: "#5aac3d",
                                        },
                                        '& .Mui-checked .MuiSwitch-thumb': {
                                            backgroundColor: "#5aac3d",
                                        }
                                    }}
                                />
                            </MenuItem>}
                        {/* <MenuItem onClick={handleClose}>Go to prioritypassport</MenuItem> */}
                        <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                    </Menu>

                </div>
            </Toolbar>
        </AppBar>
    )
}

export default NavBarTop;